import React, { Component } from 'react';
import * as Http from '../../http'
import * as Business from '../../utils/business'
import Loading from '../../components/Loading'
import DatePicker from '../../components/Forms/ExtendedForms/DatePicker';
import moment from 'moment';
import { LimitRecord } from '../../const';

export default class Activities extends Component {
  constructor(props) {
    super(props)

    const fromDate = moment().local().startOf('day');
    const toDate = moment().local().endOf('day');


    this.state = {
      loading: true,
      data: [],
      totalRecord: 0,
      datePickerDisplay: {
        startDate: fromDate,
        endDate: toDate
      },
      fromDate: fromDate.valueOf(),
      toDate: toDate.valueOf(),
      currentPage: 1,
      defaultListPageNumber: [1, 2, 3, 4, 5]
    }
    this.getListActionLogs = this.getListActionLogs.bind(this);
    this.getDateFromDatePicker = this.getDateFromDatePicker.bind(this);
    this.choosePage = this.choosePage.bind(this);
    this.prevPage = this.prevPage.bind(this);
    this.nextPage = this.nextPage.bind(this);
  }

  componentDidMount() {
    this.getListActionLogs();
  }

  getListActionLogs = () => {
    this.setState({
      data: [],
      loading: true
    }, () => {
      Http.getListActionLogs(this.state.fromDate, this.state.toDate, this.state.currentPage, LimitRecord, this.state.searchText)
        .then(res => {
          if (res && res.Success) {
            if (res.Data) {
              this.setState({
                data: res.Data.data ? res.Data.data : [],
                totalRecord: res.Data.total_count ? res.Data.total_count : 0,
                loading: false
              })
            }
          }
        })
    })
  }

  getDateFromDatePicker({ startDate, endDate, searchText }) {
    if (startDate && endDate) {
      this.setState({
        fromDate: startDate.valueOf(),
        toDate: endDate.valueOf(),
        datePickerDisplay: { startDate, endDate },
        defaultListPageNumber: [1, 2, 3, 4, 5],
        currentPage: 1,
        searchText
      }, () => {
        this.getListActionLogs();
      })
    }
  }

  choosePage(page) {
    if (this.state.currentPage !== page) {
      this.setState({ currentPage: page }, () => {
        this.getListActionLogs();
      })
    }
  }

  nextPage() {
    let { defaultListPageNumber, currentPage, data } = this.state;
    const maxPage = defaultListPageNumber[4];
    const nextPage = currentPage + 1;

    if (data.length === 0 || data.length < LimitRecord) {
      Business.showAlert({
        title: '',
        content: 'No data to show.'
      })
      return;
    }

    if (nextPage > maxPage) {
      defaultListPageNumber = defaultListPageNumber.map(e => e + defaultListPageNumber.length);
      currentPage = nextPage;
    } else {
      currentPage = nextPage;
    }
    this.setState({
      currentPage: currentPage,
      defaultListPageNumber: defaultListPageNumber
    }, () => {
      this.getListActionLogs();
    })
  }

  prevPage() {
    let { defaultListPageNumber, currentPage } = this.state;
    const minPage = defaultListPageNumber[0];
    const prevPage = currentPage - 1;

    if (prevPage === 0) {
      return;
    }

    if (prevPage < minPage) {
      defaultListPageNumber = defaultListPageNumber.map(e => e - defaultListPageNumber.length);
      currentPage = prevPage;
    } else {
      currentPage = prevPage;
    }
    this.setState({
      currentPage: currentPage,
      defaultListPageNumber: defaultListPageNumber
    }, () => {
      this.getListActionLogs();
    })
  }

  renderRow = (item) => (
    <tr key={item.action_log_id}>
      <td>{item.username}</td>
      <td>{item.fullname}</td>
      <td>{item.action}</td>
      <td>
        {Business.convertToFullDate(item.time)}
      </td>
    </tr >
  )

  render() {
    if (this.state.loading) return <div style={{ height: Business.getHeightContent() }}><Loading size="small" /></div>

    return (
      <div className="card">
        <div className="header">
          <h4 className="title">Activities</h4>
        </div>
        <div style={{ height: 15 }} />
        <div className="content table-responsive table-full-width" style={{ minHeight: 400 }}>
          <div style={{ display: 'flex', alignContent: 'center', justifyContent: 'space-between', alignItems: 'center' }}>
            <DatePicker isHideSearchText={true} searchText={this.state.searchText} datePickerDisplay={this.state.datePickerDisplay} getDate={this.getDateFromDatePicker} />
            <a onClick={() => { this.getListActionLogs(); }} style={{ color: '#5252ff' }}>Refresh</a>
          </div>
          <table className="table table-hover table-striped">
            <thead>
              <tr>
                <th>Username</th>
                <th>Full Name</th>
                <th>Action</th>
                <th>Time</th>
              </tr>
            </thead>
            <tbody>
              {this.state.data.map(item => {
                if (Business.isCurrentUser(item.username)) {
                  return this.renderRow(item);
                }
              })}
            </tbody>
          </table>
        </div>
        <div className="content" style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}>
          <ul className="pagination pagination-no-border">
            <li onClick={() => this.prevPage()}><a>«</a></li>
            {
              this.state.defaultListPageNumber.map((page) => {
                if (page <= this.state.totalRecord / LimitRecord + 1) {
                  return <li
                    key={page}
                    className={this.state.currentPage === page ? "active" : ""}
                    onClick={() => this.choosePage(page)}
                  ><a >{page}</a></li>
                }
              })
            }
            <li onClick={() => this.nextPage()}><a >»</a></li>
          </ul>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/Activities/Activities.js